const rotationLocale = {
  rotation: {
    title: "Déménagement",
    rotationRequest: "Déclarer un déménagement",
    detachSubscriber: "Détacher l'adhérent",
    siteWithAppointment:
      "Ce site a un rendez-vous de planifié. Il n’est pas possible de détacher l’adhérent si le rendez-vous est maintenu.",
    deleteAppointment: "Supprimer le rendez-vous avant détachement",
  },
};

export type RotationLocale = typeof rotationLocale;
export default rotationLocale;
